export default{
  'engagement_churn_Churn': '流失',
  'engagement_churn_All_Users': '所有用户流失', // 2
  'engagement_churn_New_Users': '新进用户流失',
  'engagement_churn_Churn_Users': '流失用户',

  'engagement_churn_Weekly_Churn_Users_and_Churn%': '周流失用户和流失率', // 4
  'engagement_churn_Biweekly_Churn_Users_and_Churn%': '双周流失用户和流失率', // 7
  'engagement_churn_Weekly_Churn_Users': '周流失用户', // 5
  'engagement_churn_Monthly_Churn_Users': '月流失用户', //
  'engagement_churn_Weekly_Churn%': '周流失率', // 6
  'engagement_churn_Monthly_Churn%': '月流失率', //
  'engagement_churn_Biweekly_Churn_Users': '双周流失用户', // 8
  'engagement_churn_Biweekly_Churn%': '双周流失率', // 9
  // Country/Region/Zone Breakdown 模块
  'engagement_churn_Country/Region/Zone_Breakdown': '国家/区域/区服排行榜', // 1
  'engagement_churn_Country': '国家',
  'engagement_churn_Region': '区域',
  'engagement_churn_Zone': '区服',
  'engagement_churn_Countries': '国家',
  'engagement_churn_Regions': '区域',
  'engagement_churn_Zones': '区服',
  'engagement_churn_Share_Of_All': '全局占比', // 14
  'engagement_churn_Churn_of_top_10_Countries': '流失用户 TOP 10 国家', // 11
  'engagement_churn_Churn_of_top_10_Regions': '流失用户 TOP 10 区域',
  'engagement_churn_Churn_of_top_10_Zones': '流失用户 TOP 10 区服',

  'engagement_churn_Sum_Churn': '流失总数', // 12
  'engagement_churn_Avg.Churn%': '平均流失率', // 13
  'engagement_churn_Churn%': '流失率', 
  'engagement_churn_Weekly_Payer_Churn': '周付费流失用户', // 1
  'engagement_churn_Weekly_Payer_Churn%': '周付费用户流失率', // 1
  'engagement_churn_Weekly_Churn_level_Distribution': '周流失用户等级构成',// 4
  'engagement_churn_Monthly_Churn_level_Distribution': '月流失用户等级构成',// 4
  'engagement_churn_Monthly_Payer_Churn': '月付费流失用户', // 2
  'engagement_churn_Monthly_Payer_Churn%': '月付费用户流失率', // 3
  // "engagement_churn_Accumulated": "Accumulated", // 5
  'engagement_churn_Top_10_Level': '流失用户 Top 10 等级', // 6
  'engagement_churn_Weekly/Biweekly_Churn_Users_Details': '周/双周流失用户指标', //7
  'engagement_churn_Monthly_Churn_Users_Details': '月流失用户指标', //
  'engagement_churn_Daily_Churn_Users_Details': '流失用户指标', //Ni

  'engagement_churn_Date': '日期', // 8
  'engagement_churn_First_Day_Churn_Users_Online_Time_Distribution': '首日流失用户在线时长分布', // 1
  'engagement_churn_Churn_Tracking_for_New_Register_Users_Level': '分等级查看新进用户的流失追踪', // 2
  'engagement_churn_Register_Date': '注册日期', // 3
  'engagement_churn_Registered_Users': '新进用户', // 4
  'engagement_churn_Tracking_Day': '关键日', // 5
  'engagement_churn_Different_Date_of_New_Register_Users_Level_Churn_on_the_Same_Tracking_Day': '不同注册日期的用户在同一个流失窗口下各个等级流失趋势',


  'engagement_churn_This_Week': '当周',
  'engagement_churn_This_Month': '当月',
  'engagement_churn_Last_Year': '去年同期',
  'engagement_churn_SWLM': '上月同期',
  'engagement_churn_SMLY': '去年同期',

  'engagement_churn_breakdown_title': '流失用户 Top 10 ',
  'engagement_churn_breakdown_table_header2': '流失',
  'engagement_churn_breakdown_table_header2_sum': '流失总数',
  'engagement_churn_breakdown_table_header3': '流失率',
  'engagement_churn_breakdown_table_header3_avg': '平均流失率',
  'engagement_churn_breakdown_share': '占比',

  'engagement_churn_new_first_day_y_title': '流失用户',
  'engagement_churn_new_first_day_chart_title': '注册日期',
  'engagement_churn_new_tacking_new_title': '分等级查看新进用户的流失追踪',

  
  'engagement_churn_level_distribution_chart_level': '等级',
  'engagement_churn_level_distribution_chart_churn_users': '流失用户',

  'engagement_churn_Accumulated':'聚合呈现',

  'engagement_churn_rank_title_platform': '各平台流失用户',
  'engagement_churn_rank_title_country': '流失用户 Top 10 国家',
  'engagement_churn_rank_title_region': '流失用户 Top 10 区域',
  'engagement_churn_rank_title_zone': '流失用户 Top 10 区服',
  'engagement_churn_breakdown_churn': '流失用户',

  'engagement_churn_Churn_Users_and_Churn%': '流失用户和流失率',
  'engagement_churn_Churn_level_Distribution_Daily': '流失用户等级构成',
  'engagement_churn_Churn_New_User_Ni': '新增流失用户',
  'engagement_churn_Accumualte_Churn_Users_Ni': '累计流失用户',
  'engagement_churn_Accumualte_Churn%_Ni': '累计流失率',
  'engagement_churn_Accumulated_Ni': '累计流失',
  'engagement_churn_Sum_Churn_Ni': '流失总数',
  'engagement_churn_Churn_Ni': '流失用户',

  'engagement_churn_Inactivity_level_1' : '7天未登录',
  'engagement_churn_Inactivity_level_2' : '14天未登录',
  'engagement_churn_Inactivity_level_3' : '28天未登录',
  'engagement_churn_Churned' : '30天未登录',
  'engagement_churn_Stale' : '60天未登录',

  'engagement_churn_content_Inactivity_Level_1': '连续7天以上未登录的用户将被标记为流失级别：“7天未登录”',
  'engagement_churn_content_Inactivity_Level_2': '连续14天以上未登录的用户将被标记为流失级别：“14天未登录”',
  'engagement_churn_content_Inactivity_Level_3': '连续28天以上未登录的用户将被标记为流失级别：“28天未登录”',
  'engagement_churn_content_Churned': '连续30天以上未登录的用户将被标记为流失级别：“30天未登录”',
  'engagement_churn_content_Stale': '连续60天以上未登录的用户将被标记为流失级别：“60天未登录”'
}
